"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _excluded = ["fill"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*eslint-disable */
var _default = function _default(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#B2ADA6' : _ref$fill,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("g", {
    "data-testid": "moon-icon"
  }, /*#__PURE__*/_react["default"].createElement("path", _extends({}, rest, {
    d: "M5.06839 7.83852C4.19881 5.68564 4.42069 3.36354 5.47349 1.48481C5.88456 0.751254 5.37908 -0.256224 4.59976 0.0595849C0.835094 1.58063 -0.983753 5.86558 0.537291 9.63025C2.05834 13.3949 6.343 15.2135 10.1077 13.6924C10.8557 13.3912 10.5442 12.3569 9.77193 12.1247C7.70995 11.5048 5.93774 9.98919 5.06839 7.83852Z",
    fill: fill
  })));
};

exports["default"] = _default;